<template>
  <div>
    <div class="inner-content">
      <Spinner :isLoading="isLoading"/>
      <h2>{{ $t('contact') }}</h2>
      <p class="mb30" v-html="$t('the_content_you_entered_is_as_follows')">
      </p>

      <h3 class="mb20">{{ $t('please_enter_your_contact') }}</h3>

      <form @submit.prevent="onSendContact()" method="post">
        <div class="contact-form-area clearfix mb30">
          <p class="ttl-pos">{{ $t('contents_of_contact') }}</p>
          <div class="contact-form-pos" data-private>
            <p style="white-space: pre-line">{{ contact.content }}</p>
          </div>
        </div>

        <h3 class="mb20">{{ $t('please_enter_your_customer_information') }}</h3>
        <div class="contact-form-area clearfix mb20">
          <p class="ttl-pos">{{ $t('doctor_name') }}</p>
          <div class="contact-form-pos">
            <p>{{ contact.name }}</p>
          </div>
        </div>

        <div class="contact-form-area clearfix mb20">
          <p class="ttl-pos">{{ $t('facility_name') }}</p>
          <div class="contact-form-pos">
            <p>{{ contact.facilityName }}</p>
          </div>
        </div>

        <div class="contact-form-area clearfix mb50">
          <p class="ttl-pos">{{ $t('email_address') }}</p>
          <div class="contact-form-pos">
            <p>{{ contact.email }}</p>
          </div>
        </div>
        <div class="cont-btn-area clearfix">
          <button type="submit" style="border: #ffa300" class="btn-cont-base mb20">
            <a href="javascript:;">
              <p>{{ $t('send') }}</p>
            </a>
          </button>
          <div class="btn-cont-cancel mb20" @click="onCancel()">
            <a href="javascript:;">
              <p>{{ $t('cancel') }}</p>
            </a>
          </div>
        </div>
      </form>
    </div>
    <ErrorDialog :content="errorMsg" />
  </div>
</template>

<script>
import { Strings } from "@/js/commons/strings"
import { mapState } from 'vuex'
import Spinner from '@/js/components/Spinner'
import { BModal, VBModal, BButton } from 'bootstrap-vue'
import ErrorDialog from '@/js/components/Common/ErrorDialog'

export default {
  data() {
    return {
      Strings: Strings,
      isLoading: false
    }
  },
  directives: { BModal, VBModal, BButton },
  components: {
    Spinner,
    ErrorDialog,
    BModal,
    BButton
  },
  mounted() {
    this.screenTracking(this.$t('contact_input_confirmation'))
    if (Object.keys(this.$store.state.contact.contact).length === 0) {
      this.$router.push({ path: '/contact-form' }).catch(err => {})
    }
  },
  computed: {
    ...mapState({
      contact: state => state.contact.contact,
      errorMsg: state => state.contact.errorMsg
    })
  },
  methods: {
    async onSendContact() {
      this.isLoading = true
      const params = {
        content: this.contact.content,
        name: this.contact.name,
        facility_name: this.contact.facilityName,
        email: this.contact.email,
        user_agent: navigator.userAgent,
        user_type: this.$store.state.auth.typeOfUser
      }
      await this.$store.dispatch('contact/sendContact', params)
      .then( res => {})
      .catch((error) => {console.log(error)})
      if (!this.errorMsg) {
        this.$store.dispatch('contact/init')
        this.$router.push({ path: '/contact-finished' }).catch(err => {})
      } else {
        this.$bvModal.show('modal-error')
      } 
      this.isLoading = false
    },
    onCancel() {
      this.$router.push({ path: '/contact-form' }).catch(err => {})
    }
  }
};
</script>
<style scoped>
  .ttl-pos {
    padding-top: 0px !important;
  }
</style>
